export const YFM_MARKDOWN_CLASSNAME = 'yfm';
export const YFM_CUT_MARKDOWN_CLASSNAME = 'yfm-cut';
export const YFM_LATEX_CLASSNAME = 'yfm-latex';
export const YFM_MERMAID_CLASSNAME = 'mermaid';
